import React from 'react';
import './termsandconditions.css';
export default function Termsandconditions() {
  return (
    <section id="terms-conditions-section">
      <div id="terms-conditions-cont">
        <h1>Terms and Conditions</h1>
        <p><strong>Effective Date:</strong> [Insert Date]</p>
        
        <h2>1. Introduction</h2>
        <p>Welcome to <strong>spkhub.netlify.app</strong>. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please review these terms carefully before using our website. If you do not agree to these terms, you should not use our website.</p>

        <h2>2. Use of Our Website</h2>
        <p>Our website is available to you free of charge and is accessible without any verification or registration. You may use our website for lawful purposes only and agree not to engage in any activities that may disrupt or harm the functionality of the website.</p>

        <h2>3. Content</h2>
        <p>All content on the website, including text, images, and videos, is provided for informational purposes. We do not guarantee the accuracy, completeness, or reliability of the content, and you should not rely solely on the information provided. We are not responsible for any errors or omissions in the content.</p>

        <h2>4. Third-Party Services</h2>
        <p>Our website integrates with third-party services to enhance functionality. These services may include, but are not limited to, advertising services like Google AdSense. These third-party services may collect certain information as described in their privacy policies. However, we do not directly collect, store, or process any personal data from users.</p>

        <h2>5. Advertising</h2>
        <p>Our website may display ads through third-party services like Google AdSense. Google may use cookies to serve personalized ads based on your browsing activity. For more details, refer to Google's <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">AdSense Privacy Policy</a>.</p>

        <h2>6. No Collection of Personal Data</h2>
        <p>We do not collect any personal information from visitors to our site. You are not required to provide any personal data to access or use our website. We do not use any user data for any purpose.</p>

        <h2>7. Cookies</h2>
        <p>Our website does not use cookies or any similar tracking technologies. However, third-party services used on our site, such as advertising providers, may set cookies to personalize ads or track usage for analytical purposes.</p>

        <h2>8. Limitation of Liability</h2>
        <p>We do not accept responsibility for any loss, damage, or inconvenience arising from your use of this website, including any issues related to third-party services or advertisements displayed on the site.</p>

        <h2>9. Changes to Terms</h2>
        <p>We may update these Terms and Conditions from time to time. Any changes will be reflected on this page, and the updated date will be noted at the top. We encourage you to review these terms periodically to stay informed about any changes.</p>

        <h2>10. Contact Us</h2>
        <p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
        <p>Email: <a href="mailto:prasannasimha5002@gmail.com">prasannasimha5002@gmail.com</a></p>
      </div>
    </section>
  );
}
